// extracted by mini-css-extract-plugin
export default {"login":"login_login__S4+5n","headline":"login_headline__bB3-y"};